module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h5', [_vm._v("Forgot Password?")]), _vm._v(" "), (_vm.errors.any()) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('email')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n          Please enter an email\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.success) ? _c('form', {
    attrs: {
      "name": "formforgotpw"
    }
  }, [_c('p', [_vm._v("Enter Email Address: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "type": "text",
      "name": "email",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": _vm._s(_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('input', {
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "Reset Password"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.reset($event)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "success-box",
    attrs: {
      "id": "success"
    }
  }, [_vm._v("\n        Password reset has been sent! "), _c('span', {
    staticClass: "close"
  }, [_vm._v("x")])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Check your email for the new password. Please be sure to check your spam folder. ")]), _vm._v(" "), _c('p', [_vm._v("Please contact support@stumpthespread if you have forgotten your login id.")])]), _vm._v(" "), _c('sidebar', {
    attrs: {
      "testimonial": _vm.testimonial
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-047bcdd8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ForgotPassword.vue
// module id = 478
// module chunks = 1